import React, { Component } from "react";
import {
    Panel,
    Modal,
    Button
}                           from "react-bootstrap";
  import {
    ToastContainer,
    toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";

import CrudComponent        from "./../zynappse-crud";
import VoucherCardTypeSchema 
                            from "./VoucherCardTypeSchema.js";
import FormContainer        from "./FormContainer";
import saveTrail            from '../../utils/saveTrail';

import {
    IS_VALID
}                           from "utils";

class EVoucherCardType extends Component {
    constructor (props) {
        super(props);

        this.refreshTableReference;
        
        this.refreshTable = this.refreshTable.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.saveData = this.saveData.bind(this);
        this.deleteData = this.deleteData.bind(this);
    }

    refreshTable () {
        if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
            this.refreshTableReference();
        }
    }

    renderModalButton () {
        let {
            EVoucherCardType,
            actions
        } = this.props;

        let {
            formType,
            isLoadingAction
        } = EVoucherCardType;

        let buttons = [];

        let button = (name, callback) => (
            <Button
                bsStyle="primary"
                onClick={() => callback()}
                disabled={isLoadingAction}
            >
                {isLoadingAction ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}
                {name}
            </Button>
        );

        let buttonClose = (
            <Button
                disabled={isLoadingAction}
                onClick={() => {
                    if (!isLoadingAction) {
                        actions.setValue({
                            showModal: false
                        });
                    }
                }}
            >
                CLOSE
            </Button>
        );

        switch (formType.toUpperCase()) {
            case "CREATE":
                buttons.push(
                    button("CREATE", this.saveData),
                    buttonClose
                );
                break;
            case "UPDATE":
                buttons.push(
                    button("UPDATE", this.saveData),
                    buttonClose
                );
                break;
            case "DELETE":
                buttons.push(
                    button("DELETE", this.deleteData),
                    buttonClose
                );
                break;
            default:
                break;
        }
        return buttons;
    }

    saveData () {
        let {
            EVoucherCardType,
            actions
        } = this.props;

        let {
            selectedData,
            formType,

            cardType
        } = EVoucherCardType;

        if (
            !IS_VALID(cardType) ||
            !IS_VALID(cardType.trim())
        ) {
            toast.error("Card Type is required.");
        } else {
            actions.setValue({
                isLoadingAction: true
            });

            let voucherCardType = new Parse.Object("VoucherCardType");

            if (
                formType === "UPDATE" &&
                IS_VALID(selectedData)
            ) {
                voucherCardType = selectedData;
            }

            voucherCardType.set("name", cardType.trim());

            voucherCardType.save()
            .then((data) => {
                 actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();

                saveTrail(
                    formType.toUpperCase(),
                    {
                        id: data.id,
                        cardType: cardType.trim()
                    }    
                );
            })
            .catch((err) => {
                console.log("saveData error");
                console.log(err);

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();
            });
        }
    }

    deleteData () {
        let {
            EVoucherCardType,
            actions
        } = this.props;

        let {
            selectedData
        } = EVoucherCardType;

        actions.setValue({
            isLoadingAction: true
        });

        selectedData.set("isDeleted", true);

        selectedData.save()
        .then((data) => {
            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();

            saveTrail(
                "DELETE",
                {
                    id: selectedData.id,
                    cardType: selectedData.get("name")
                }
            );
        })
        .catch((err) => {
            console.log("saveData error");
            console.log(err);

            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();
        });
    }

    render () {
        let {
            EVoucherCardType,
            accessjson,
            actions
          } = this.props;
      
          let {
            showModal,
            isLoadingAction,

            selectedData,
            formType,
            formTitle,

            cardType
          } = EVoucherCardType;

        let crudProps = {
            schema: VoucherCardTypeSchema,
            access: accessjson.access,
            moduleQuery: [
                { method: "ascending", column: "name" }
            ],
            refreshTable: (refreshTable) => {
                this.refreshTableReference = refreshTable;
            },
            customCreate: () => {
                actions.setValue({
                    showModal: true,
                    formType: "CREATE",
                    formTitle: "CREATE"
                });
            },
            customUpdate: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "UPDATE",
                    formTitle: "UPDATE",
                    formId: obj.id,
                    selectedData: obj
                };

                if (IS_VALID(obj.get("name"))) {
                    stateToUpdate.cardType = obj.get("name");
                }

                actions.setValue(stateToUpdate);
            },
            customDelete: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "DELETE",
                    formTitle: "DELETE",
                    formId: obj.id,
                    selectedData: obj
                };

                actions.setValue(stateToUpdate);
            }
        };

        let formContainerProps = {
            actions,

            formType,
            selectedData,

            cardType
        };

        return (
            <div>
                <Panel>
                    <Panel.Heading style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                    }}>
                        <h4>EVoucher Card Type</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <CrudComponent {...crudProps}/>
                    </Panel.Body>
                </Panel>
                <Modal
                    bsSize={formType === "DELETE" ? null : "sm"}
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                     <Modal.Header closeButton>
                        <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormContainer {...formContainerProps}/>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </div>
        );
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
    SET_EVOUCHER_CARD_TYPE
}                           from "actions/const";

function mapStateToProps(state) {
	var {
		accessjson,
        EVoucherCardType
	} = state;
	return {
		accessjson,
        EVoucherCardType
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObj, actioType = SET_EVOUCHER_CARD_TYPE) => generics.setValue(actioType, keyValueObj)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EVoucherCardType);


// WEBPACK FOOTER //
// ./components/EVoucherCardType/index.js